import React from 'react';
import get_bundle from '../../../domain/get_bundle';
import Locale from '../../../domain/Locale';
import Widget from '../../../domain/Widget';
import WidgetLayout from '../../../components/WidgetLayout';
import WidgetHeader from '../../../components/WidgetHeader';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  captcha_url: t.Str,
  widget: t.maybe(Widget)
})
export default class Captcha extends React.Component {

  getHeader() {
    return (<WidgetHeader widget={this.props.widget}/>);
  }

  getWidgetFooterImage() {
    if (!this.props.widget) {
      return null;
    }
    return this.props.widget.footer_image;
  }

  render() {
    const {locale} = this.props;
    const bundle = get_bundle(locale).captcha;
    return (
      <WidgetLayout header={this.getHeader()} locale={locale}>
        <div id='captcha'>
          <h1><strong>{bundle.disclaimer}</strong></h1>
          <iframe id="captcha_iframe" src={this.props.captcha_url}></iframe>
        </div>
      </WidgetLayout>
    );
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/widget/Captcha.js
 **/